import { IconFunctionalWarningSign16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { useComplaintToOfferAction } from '@/microfrontends/listing/shared/hooks/card/useComplaintToOfferAction';

import { CardNarrowMenuItem } from '../../../../components/CardNarrowMenuItem';

export const MenuItemComplaintContainer: FC = () => {
  const complaintToOffer = useComplaintToOfferAction();

  const handleClick = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      complaintToOffer();
    },
    [complaintToOffer],
  );

  return <CardNarrowMenuItem icon={<IconFunctionalWarningSign16 />} title="Пожаловаться" onClick={handleClick} />;
};
